import { makeStyles } from '@material-ui/core/styles';

export const SectionStyles =
makeStyles((theme) => ({
    sectionContainer: {
        //paddingTop: theme.spacing(8),
        //paddingBottom: theme.spacing(8),
        //paddingRight: "6%",
        //paddingLeft: "6%",
        backgroundColor: theme.palette.background.paper,
        overflowX: "hidden",
        overflowY: "hidden", //this is to fix margin collapsing
    },
}));